import { userProfileImages } from '../../services/images.service'

export function UserDetailsDesktop({ user }) {
  return (
    <section className="grid grid-cols-5 grid-rows-4 gap-4 h-[250px] w-full text-white">
      {/* 1. קצת עליי */}
      <div className="col-span-2 row-span-4 bg-[#252525] p-6 flex flex-col justify-start gap-4 overflow-hidden">
        <h5 className="text-muted text-h5">קצת עליי</h5>
        <p className="text-softText text-h5 break-words line-clamp-6">
          {user.bio || 'לא צויין'}
        </p>
      </div>

      {/* 2. אנימה מועדפת */}
      <div className="row-span-2 col-start-3 bg-[#252525] p-4 flex flex-col justify-center">
        <h5 className="text-muted text-h5 mb-2">אנימה מועדפת</h5>
        <p className="text-softText text-h5">
          {user.favoriteAnime || 'לא צויין'}
        </p>
      </div>

      {/* 3. דמות מועדפת */}
      <div className="row-span-2 col-start-4 bg-[#252525] p-4 flex flex-col justify-center">
        <h5 className="text-muted text-h5 mb-2">דמות מועדפת</h5>
        <p className="text-softText text-h5">
          {user.favoriteCharacter || 'לא צויין'}
        </p>
      </div>

      {/* 4. ציטוט מועדף */}
      <div className="col-span-2 row-span-2 col-start-3 row-start-3 bg-[#252525] p-4 flex justify-between items-center">
        <div>
          <h5 className="text-muted text-h5 mb-2">ציטוט מועדף</h5>
          <p className="text-softText text-h5">
            {user.favoriteQuote || 'לא צויין'}
          </p>
        </div>
        <img src={userProfileImages.quoteIcon} alt="Quote Icon" />
      </div>

      {/* 5. קטגוריות מועדפות */}
      <div className="row-span-4 col-start-5 row-start-1 bg-[#252525] px-6 py-7 flex flex-col justify-start">
        <h5 className="text-muted text-h5 mb-3">קטגוריות מועדפות</h5>
        <div className="flex flex-col gap-3 mt-3">
          {[0, 1, 2].map((index) => (
            <div key={index}>
              <div className="flex items-center gap-3">
                <h5 className="text-primary ">
                  <span>0</span>
                  {index + 1}
                </h5>
                <h5 className="text-softText text-h5">
                  {user.favoriteCategories?.[index] || 'לא צויין'}
                </h5>
              </div>
              {index !== 2 && (
                <div className="w-full h-[1px] bg-[rgba(255,255,255,0.10)] my-3" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
